"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPaymentCollectorComponent = void 0;
const core_1 = require("@angular/core");
const billing_service_1 = require("../../billing/services/billing.service");
// import { DOCUMENT } from '@angular/platform-browser';
class CSPaymentCollectorComponent {
    constructor(billingService, collector, _document) {
        this.billingService = billingService;
        this.collector = collector;
        this._document = _document;
    }
    ngOnInit() {
        this.getPaymentCollector();
    }
    getPaymentCollector() {
        this.billingService.getPaymentCollector().subscribe((res) => {
            this.sessionId = res.sessionId;
            this.merchantId = res.merchantId;
            this.companyUrl = res.companyUrl;
            this.URL = this.companyUrl + '/collect/sdk?m=' + this.merchantId + '&s=' + this.sessionId;
            const pay = this.collector.createElement('script');
            pay.type = 'text/javascript';
            pay.src = this.URL;
            pay.text = '';
            pay.onload = pay.onreadystatechange = function () {
                if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                    setTimeout(function () {
                        const client = new this.ka.ClientSDK();
                        client.autoLoadEvents();
                    }, 650);
                }
            };
            this.collector.appendChild(this._document.body, pay);
        }, (err) => {
            this.errors = err;
        });
    }
}
exports.CSPaymentCollectorComponent = CSPaymentCollectorComponent;
//# sourceMappingURL=paymentcollector.js.map